import { useState } from "react"
import styled from "styled-components"
import InputText from "../../shared/input/new/InputText"
import Btn from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"
import InputDate from "../../shared/input/new/InputDate"
import InputTextarea from "../../shared/input/new/InputTextarea"
import InputCityTown from "../../shared/input/new/InputCityTown"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputSelectMultiple from "../../shared/input/new/InputSelectMultiple"

import ehliyetOptions from "../../../utils/ehliyetOptions"
import srcOptions from "../../../utils/srcOptions"
import PageTopTitle from "../../shared/PageTopTitle"
import { addAdminUye, getUserPhoneNumberUnique, getUserTcApprove } from "../../../features/admin2/admin2Slice"
import moment from "moment"
import InputSelect from "../../shared/input/new/InputSelect"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0 20px;
            width: 900px;
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height: 600px;
            overflow: auto;

            .input-grp{
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                gap: 5px;
                margin-bottom: 20px;

                &:nth-child(1), &:nth-child(4){
                    flex-direction: row;
                    justify-content: space-between;
                    gap: 20px;
                }

                .input-column{
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                input{
                    border: 1px solid ${({theme}) => theme.mainBorderColor};
                    border-radius: 5px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }

                p{
                    font-size: 10px;
                    color: var(--color-main);
                }

            }

            .tc-btn-error{
                font-size: 12px;
                color: var(--color-main);
                padding-bottom: 10px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin-bottom: 30px;
            gap: 40px;
        }
    }
`

const kolayAdresTypes = [
    {
        id: 1,
        text: "TC No"
    },
    {
        id: 2,
        text: "Telefon"
    },
    {
        id: 3,
        text: "Vergi No"
    },
    {
        id: 4,
        text: "Pasaport No"
    },
    {
        id: 5,
        text: "Mail"
    },
]

const eYurtKayitliMiOptions = [
    {
        value: true,
        text: "Evet"
    },
    {
        value: false,
        text: "Hayır"
    }
]

const referanceCardData = [
    {
        value: true,
        text: "Evet"
    },
    {
        value: false,
        text: "Hayır"
    }
]

const AdminUyeEkleModal = () => {

    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)
    const {isLoadingAddAdminUye, isLoadingGetUserPhoneNumberUnique, userPhoneNumberUniqueResData, isLoadingGetUserTcApprove, userTCApprovedResData, } = useSelector(state => state.admin2)

    const location = useLocation()
    const dispatch = useDispatch()


    const [isSubmitted, setIsSubmitted] = useState(false)

    const [isTcBtnClicked, setIsTcBtnClicked] = useState(false)

    const [referanceStatus, setReferanceStatus] = useState(null)
    const [ehliyetTypes, setEhliyetTypes] = useState([])
    const [kolayAdresType, setKolayAdresType] = useState(null)
    const [srcTypes, setSrcTypes] = useState([])
    const [eYurtKayitliMi, setEYurtKayitliMi] = useState(null)
    const [cityTown ,setCityTown] = useState(null)
    const [formData, setFormData] = useState({
        tcNo: "",
        adSoyad: "",
        dogumTarihi: "",
        phoneNumber: "",
        iban: "",
        adres: "",
        firmaKooperatif:"",
        bankaBilgisiHesapSahibi: "",
        eYurtNo: "",
        kolayAdres: "",
        kooperatifUyelikTarihi:"",
        eyurtKayitTarihi:""
    })

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    
    useEffect(() => {
        if(eYurtKayitliMi?.value){
            const date = new Date()
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ayı 2 haneli hale getiriyoruz
            const day = date.getDate().toString().padStart(2, '0'); // Günü 2 haneli hale getiriyoruz
            
            const formattedDate = `${year}-${month}-${day}`;
            setFormData((prev) => ({ ...prev, eyurtKayitTarihi: formattedDate }))
        }
        else{
            setFormData((prev) => ({ ...prev, eyurtKayitTarihi: "" }))
        }
    },[eYurtKayitliMi?.value])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e, isNumber) => {
        if(isNumber){
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value.replace(/[^0-9]/g, '')}))
        }
        else{
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
        }
    }

    const handleTCApprove = () => {
        setIsTcBtnClicked(true)
        if(formData.tcNo && formData.adSoyad && formData.dogumTarihi){
            dispatch(getUserTcApprove({tckn: formData.tcNo, adSoyadUnvan: formData.adSoyad, dogumTarihi: formData.dogumTarihi}))
        }
    }

    const handleSubmit = () => {
        setIsSubmitted(true)
        // formData.tcNo && formData.phoneNumber && formData.adSoyad && formData.adres && cityTown?.location && ehliyetTypes.length > 0 && srcTypes.length > 0
        if(formData.tcNo && formData.phoneNumber && formData.adSoyad && cityTown?.location && formData?.tcNo?.length === 11 ){


            const data = {
                phoneNumber: formData.phoneNumber,
                tckn: formData.tcNo,
                adSoyadUnvan: formData.adSoyad,
                dogumTarihi: formData.dogumTarihi,
                adressContent: formData.adres,
                bankaBilgisiHesapSahibi: formData.bankaBilgisiHesapSahibi,
                iban: formData.iban.trim(),
                kolayAdresType: kolayAdresType?.text,
                kolayAdres:formData.kolayAdres,
                kooperatif: formData.firmaKooperatif,
                kooperatifUyelikTarihi: formData?.kooperatifUyelikTarihi !== "Invalid date" ? formData?.kooperatifUyelikTarihi : null,
                isEgeYurt: eYurtKayitliMi?.value,
                eyurtKayıtTarihi: formData?.eyurtKayitTarihi !== "Invalid date" ? formData?.eyurtKayitTarihi : null,
                eyurtNumber: parseInt(formData.eYurtNo) || 0,
                IsTcNoValid: (userTCApprovedResData?.res && userTCApprovedResData?.tckn === formData.tcNo && userTCApprovedResData?.dogumTarihi === formData.dogumTarihi && userTCApprovedResData?.adSoyadUnvan === formData.adSoyad),
                IsReferenceCard: referanceStatus?.value,
                
            }
            dispatch(addAdminUye(
                {
                    ...data,
                    il: cityTown?.city,
                    ilce: cityTown.town,
                    srcTypes: srcTypes.map(item => {
                        return {srcBelgesi: item.value}
                    }),
                    ehliyetTypes: ehliyetTypes.map(item => {
                        return {ehliyet: item.value}
                    })
                }
            ))
        }
    }

  return (
    <ModalContainer>
        <div className="modal" onClick={() => dispatch(handleActiveSelect(null))}>
            <PageTopTitle title={"Üye Ekle"}/>
            <div className="content">
                <div className="input-grp">
                    <div className="input-column">
                        <InputText data={formData.phoneNumber} setData={(e) =>handleChange(e, true)} inputWidth={"210px"} labelText="Telefon Numarası" name={"phoneNumber"}/>
                        {
                            (!formData.phoneNumber && isSubmitted) &&
                            <p>Telefon bilgisi girilmesi zorunludur</p>
                        }
                    </div>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"210px"} handleClick={() => dispatch(getUserPhoneNumberUnique(formData.phoneNumber))}>{isLoadingGetUserPhoneNumberUnique ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : (!userPhoneNumberUniqueResData?.res && userPhoneNumberUniqueResData?.checkedPhoneNumber === formData.phoneNumber) ? "Numara Kullanılabilir" : "Kontrol Et"}</Btn>
                </div>
                

                <div className="input-grp">
                    <InputText data={formData.adSoyad} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Adı Soyadı" name={"adSoyad"}/>
                    {
                        (!formData.adSoyad && isSubmitted) &&
                        <p>Ad Soyad bilgisi girilmesi zorunludur</p>
                    }
                </div>

                <div className="input-grp">
                    <InputDate data={formData.dogumTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Doğum Tarihi" name={"dogumTarihi"}/>
                </div>

                <div className="input-grp">
                    <div className="input-column">
                        <InputText data={formData.tcNo} setData={(e) => handleChange(e, true)} inputWidth={"210px"} labelText="TC No" name={"tcNo"}/>
                        {
                            (!formData.tcNo && isSubmitted) &&
                            <p>TC No bilgisi girilmesi zorunludur</p>
                        }
                        {
                            (formData?.tcNo && formData?.tcNo?.length !== 11 && isSubmitted) &&
                            <p>TC No 11 haneli olmalıdır.</p>
                        }
                    </div>
                    <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"210px"} handleClick={() => handleTCApprove()}>{isLoadingGetUserTcApprove ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : (userTCApprovedResData?.res && userTCApprovedResData?.tckn === formData.tcNo && userTCApprovedResData?.dogumTarihi === formData.dogumTarihi && userTCApprovedResData?.adSoyadUnvan === formData.adSoyad) ? "Doğrulandı" : "Doğrula"}</Btn>
                </div>
                    {
                        (isTcBtnClicked && (!formData.tcNo || !formData.adSoyad || !formData.dogumTarihi)) &&
                        <p className="tc-btn-error">
                            TC Numarası Doğrulaması için TC Numarası, Ad Soyad ve Doğum Tarihi bilgisini giriniz.  
                        </p>
                    }

                <div className="input-grp">
                    <InputTextarea data={formData.adres} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Adres" name={"adres"}/>
                    {/* {
                        (!formData.adres && isSubmitted) &&
                        <p>Adres bilgisi girilmesi zorunludur</p>
                    } */}
                </div>

                <div className="input-grp">
                    <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"440px"} labelText="İl/İlçe" name={"cityTown"}/>
                    {
                        (!cityTown?.location && isSubmitted) &&
                        <p>İl/İlçe bilgisi girilmesi zorunludur</p>
                    }
                </div>

                <div className="input-grp">
                    <InputSelectMultiple data={ehliyetTypes} setData={setEhliyetTypes} inputWidth={"440px"} labelText="Ehliyet Türleri" name={"ehliyetTypes"} options={ehliyetOptions}/>
                    {/* {
                        (ehliyetTypes < 1 && isSubmitted) &&
                        <p>Ehliyet bilgisi girilmesi zorunludur</p>
                    } */}
                </div>
                <div className="input-grp">
                    <InputSelectMultiple data={srcTypes} setData={setSrcTypes} inputWidth={"440px"} labelText="SRC Türü" name={"srcTypes"} options={srcOptions}/>
                    {/* {
                        (srcTypes.length < 1 && isSubmitted) &&
                        <p>SRC bilgisi girilmesi zorunludur</p>
                    } */}
                </div>
                <div className="input-grp">
                    <InputSelect data={eYurtKayitliMi?.text} setData={setEYurtKayitliMi} inputWidth={"440px"} labelText="E-Yurt Kayıtlı Mı?" name={"eYurtKayitliMi"} initialOptions={eYurtKayitliMiOptions}/>
                </div>
                <div className="input-grp">
                    <InputSelect data={referanceStatus?.text} setData={setReferanceStatus} inputWidth={"440px"} labelText="Referans Kartı Durumu" name={"referanceStatus"} initialOptions={referanceCardData}/>
                </div>
                {
                    eYurtKayitliMi?.value &&
                    <div className="input-grp">
                        <InputDate data={formData.eyurtKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="E-Yurt Kayıt Tarihi" name={"eyurtKayitTarihi"}/>
                    </div>
                }
                <div className="input-grp">
                    <InputText data={formData.bankaBilgisiHesapSahibi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Banka Bilgisi Hesap Sahibi" name={"bankaBilgisiHesapSahibi"}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.iban} setData={(e) =>handleChange(e, true)} inputWidth={"440px"} labelText="İban" name={"iban"}/>
                </div>
                <div className="input-grp">
                    <InputSelect data={kolayAdresType?.text} setData={setKolayAdresType} inputWidth={"440px"} labelText="Kolay Adres Türü" name={"kolayAdresType"} initialOptions={kolayAdresTypes}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.kolayAdres} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Kolay Adres" name={"kolayAdres"}/>
                </div>
                <div className="input-grp">
                    <InputText data={formData.firmaKooperatif} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Firma - Kooperatif" name={"firmaKooperatif"}/>
                </div>
                <div className="input-grp">
                    <InputDate data={formData.kooperatifUyelikTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Kooperatif Üyelik Tarihi" name={"kooperatifUyelikTarihi"}/>
                </div>


                {/* <div className="input-grp">
                    <InputDate data={formData.uyeKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"440px"} labelText="Üye Kayıt Tarihi" name={"uyeKayitTarihi"}/>
                </div> */}
            </div>

            <div className="button-grp">
                <Btn width={"240px"} bgColor="#E85446" color="#fff" handleClick={handleSubmit}>{isLoadingAddAdminUye ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Ekle"}</Btn>
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AdminUyeEkleModal